export default __webpack_public_path__ + "static/media/3.ee4e8737.jpg";